import { defineAction } from '~/prix'
import llmChatCreateAction from './llmChatCreate.action.json' assert { type: 'json' }
import { z } from 'zod'

const llmChatCreateDefinition = defineAction({
  ...llmChatCreateAction,

  input: z.object({
    title: z.string().nullish(),
  }),
  output: z.object({
    id: z.number(),
    title: z.string().nullish(),
    createdAt: z.string(),
  }),
})

export default llmChatCreateDefinition
